import saveAs from 'file-saver';

export async function DownloadFile(link: string, fileName: string) {
  const blob = await fetch(link).then((r) => r.blob());

  saveAs(blob, fileName);
}
